import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { PermissionProvider } from './contexts/PermissionContext';
import ETPOSDashboard from "./ETPOSDashboard";
import AddUser from "./components/AddUser";
import AddRole from "./components/AddRole";
import AddRoleNew from "./components/AddRoleNew";
import AddAgent from "./components/AddAgent";
import Login from "./components/Login";
import ForgotPassword from "./components/ForgotPassword";
import ProtectedRoute from "./components/ProtectedRoute";
import AddProduct from "./AddProduct";
import AddSupplier from "./components/ETPOS/AddSupplier";
import Profile from "./components/Profile";
import POSPage from './components/ETPOS/POSPage';
import AiAssistantDashboard from './pages/AiAssistant/index';
import GenerateTool from './pages/AiAssistant/GenerateTool';
import AiHistory from './pages/AiAssistant/History';

function App() {
  return (
    <Router>
      <PermissionProvider>
        <ToastContainer position="top-right" autoClose={3000} />
        <Routes>
          {/* Public Routes */}
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />

          {/* Standalone POS Page */}
          <Route path="/pos" element={<ProtectedRoute><POSPage /></ProtectedRoute>} />

          {/* Protected Routes */}
          <Route path="/" element={<ProtectedRoute><ETPOSDashboard /></ProtectedRoute>}>
            <Route index element={<Navigate to="/home" replace />} />
            <Route path="home" element={null} />
            <Route path="users" element={null} />
            <Route path="users/add" element={<AddUser />} />
            <Route path="roles/add" element={<AddRoleNew />} />
            <Route path="sales-commission-agents/add" element={<AddAgent />} />
            <Route path="products/add" element={<AddProduct />} />
             <Route path="contacts/suppliers/add" element={<AddSupplier />} />
             <Route path="contacts/suppliers/edit/:id" element={<AddSupplier />} />
             <Route path="contacts/customers/add" element={<AddSupplier />} />
             <Route path="contacts/customers/edit/:id" element={<AddSupplier />} />
             <Route path="profile" element={<Profile />} />
            <Route path="ai-assistant" element={<AiAssistantDashboard />} />
            <Route path="ai-assistant/history" element={<AiHistory />} />
            <Route path="ai-assistant/:toolId" element={<GenerateTool />} />
            <Route path="sell" element={null} />
            <Route path="sell/*" element={null} />
            <Route path="*" element={null} />
          </Route>

          {/* Redirect any unmatched routes to login */}
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </PermissionProvider>
    </Router>
  );
}

export default App;
